import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import $ from "jquery";

import * as R from "ramda";
import featuresOverview from "./../../../../assets/images/placeholder/Features-Overview.svg";
import { LoadingState } from "../../../../_common/loadingState";
import { DeclareModal } from "./declareModal";
import { RelocationDashboard } from "./dashboard";
import { DeleteModal } from "../_common/deleteModal";
import { getRelocationDeclaration, deleteRelocationDeclaration, updateRelocationDeclaration, fetchLifeEvents, getDocuments, getLettersForUserId, getUserConnections, getUserServiceData, generateLettersForUserId } from "../../../../actions/events-api";
import * as Loadings from "../../../../constants/loadings/relocationDeclaration";
import * as UserLoadings from "../../../../constants/loadings/user";

export const EventsRelocation = () => {
	const dispatch = useDispatch();

	const userState = useSelector((state) => state.user);
	const relocationDeclarationState = useSelector((state) => state.relocationDeclaration);

	const deleteTexts = { title: "Supprimer dossier de déménagement", body: "le dossier de déménagement" };
	const [isLoadingDelete, setIsLoadingDelete] = useState(false);
	const [stateIsLoading, setStateIsLoading] = useState(false);

	const onDeleteRelocation = () => {
		setIsLoadingDelete(true);
		dispatch(deleteRelocationDeclaration(userState.user.id))
			.then(() => {
				dispatch(fetchLifeEvents(userState.user.id));
				getDeclaration();
			})
			.finally(() => {
				setIsLoadingDelete(false);

				// Use Bootstrap modal hide instead of manually removing classes
				setTimeout(() => {
					$("#deleteDeclaration").modal("hide");
					$(".modal-backdrop").remove(); // Ensure backdrop is removed
				}, 100); // Give it a bit of time to fully process
			});
	};

	const getDeclaration = () => {
		const representing = { ...userState.user, oldAddress: userState.address, onBoardingStep: 1, id: undefined };
		dispatch(getRelocationDeclaration(userState.user.id, representing));
	};

	const onRestartRelocation = () => {
		dispatch(updateRelocationDeclaration(userState.user.id, { ...relocationDeclarationState.declaration, onBoardingStep: 1 }))
			.then(() => {
				window.location.reload(); // Reload the page to reflect the changes
			});
	};

	const generateLetters = () => {
		dispatch(generateLettersForUserId(userState.user.id, "relocation"));
	};

	useEffect(() => {
		if (!R.isNil(userState.user)) {
			dispatch(getDocuments(userState.user.id));
			dispatch(getLettersForUserId(userState.user.id, "relocation"));
			dispatch(getUserConnections(userState.user.id));
			dispatch(getUserServiceData(userState.user.id, undefined, "relocation"));
		}
	}, [dispatch, userState.user]);

	useEffect(() => {
		if (!R.isNil(userState.user) && !R.isNil(userState.address)) {
			getDeclaration();
		}
	}, [userState.address]);

	// Display Loading
	useEffect(() => {
		const _stateIsLoading =
			relocationDeclarationState.isLoading.includes(Loadings.FETCHING_RELOCATION_DECLARATION) ||
			relocationDeclarationState.isLoading.includes(Loadings.CREATING_RELOCATION_DECLARATION) ||
			relocationDeclarationState.isLoading.includes(Loadings.UPDATING_RELOCATION_DECLARATION) ||
			relocationDeclarationState.isLoading.includes(Loadings.FETCHING_USER_CONNECTION) ||
			relocationDeclarationState.isLoading.includes(Loadings.FETCHING_FILES) ||
			relocationDeclarationState.isLoading.some((item) => item.startsWith(Loadings.FETCHING_USER_SERVICES_DATA)) ||
			relocationDeclarationState.isLoading.some((item) => item.startsWith(Loadings.UPDATING_USER_SERVICES_DATA)) ||
			relocationDeclarationState.isLoading.some((item) => item.startsWith(Loadings.GENERATING_USER_LETTERS)) ||
			relocationDeclarationState.isLoading.includes(Loadings.FETCHING_USER_LETTERS) ||
			userState.isLoading.includes(UserLoadings.FETCH_LIFEEVENTS);

		if (_stateIsLoading !== stateIsLoading) {
			setStateIsLoading(_stateIsLoading);
		}
	}, [userState.isLoading, relocationDeclarationState.isLoading]);

	useEffect(() => {
		const handleModalHidden = () => {
			// Check if any modals are still open
			const anyModalsOpen = $(".modal.show").length > 0;

			if (!anyModalsOpen) {
				setTimeout(() => {
					$(".modal-backdrop").remove();
				}, 100);
			}
		};

		$(document).on("hidden.bs.modal", handleModalHidden);
		return () => {
			$(document).off("hidden.bs.modal", handleModalHidden);
		};
	}, []);

	return (
		<article className="view-calc py-2">
			{stateIsLoading ? (
				<LoadingState />
			) : (
				<div className="auto-view h-100 my-auto">
					{userState.events?.some((e) => e.type === "UserRelocation" && e.inProgress && e.step > 4) ? (
						<RelocationDashboard
							declaringUserId={userState.user.id}
							currentlyConnectedUserId={userState.user.id}
							userId={userState.user.id}
							userLetters={relocationDeclarationState.userLetters}
							declaration={relocationDeclarationState.declaration}
							relocatedUser={userState.user}
							serviceDatas={relocationDeclarationState.serviceDatas}
							connectionTypes={relocationDeclarationState.connectionTypes}
							isLoading={relocationDeclarationState.isLoading}
							files={relocationDeclarationState.files}
							relocationDate={relocationDeclarationState.declaration?.effectiveMovingDate}
							onDelete={onDeleteRelocation}
							isLoadingDelete={isLoadingDelete}						onRestart={onRestartRelocation}						/>
					) : (
						<div className="container-fluid my-auto">
							<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-5 text-center">
								<img className="img-fluid mx-auto container-md-press mb-2" src={featuresOverview} alt="features overview" width="150" />
								<div className="container-default mx-auto">
									<h2 className="text-primary font-weight-bolder mt-2 mb-3">Accompagnement aux démarches administratives</h2>
								</div>
							</header>
							<section className="block container-default mx-auto">
								<p className="h4 font-weight-black mb-2 align-items-left">Pourquoi?</p>
								<p className="mb-3">Ce service a été mis en place afin de vous accompagner et vous faciliter les démarches administratives à faire lors d’un déménagement.</p>
								<h4 className="h5 text-uppercase font-weight-bolder mt-0 mb-2">Notre service</h4>
								<div className="card mb-3">
									<div className="card-body">
										<div className="d-flex align-items-center small">
											<i className="eva eva-checkmark-outline text-success mr-2"></i>
											<span className="o-70">Vous propose les courriers personnalisés</span>
										</div>
										<div className="d-flex align-items-center small">
											<i className="eva eva-checkmark-outline text-success mr-2"></i>
											<span className="o-70">Vous informe sur les délais à respecter et les aides et allocations</span>
										</div>
										<div className="d-flex align-items-center small">
											<i className="eva eva-checkmark-outline text-success mr-2"></i>
											<span className="o-70">Les archives pour vous, dans un coffre-fort numérique disponible</span>
										</div>
										<div className="d-flex align-items-center small">
											<i className="eva eva-checkmark-outline text-success mr-2"></i>
											<span className="o-70">Vous permet de déposer simplement les documents de la famille (livrets, pièces d’identités…) dans un espace bibliothèque.</span>
										</div>
									</div>
								</div>
								<div className="card alert-primary text-body my-2 mt-sm-0 mb-sm">
									<div className="card-body d-flex align-items-start">
										<i className="eva eva-alert-triangle text-primary mr-2 h3 mt-n1"></i>
										<div className="flex-grow-1">
											<h1 className="small font-weight-bolder text-primary text-uppercase">Attention</h1>
											<p className="lh-copy mb-1">
												Assurez-vous d'avoir complété la case <b>«Autres abonnements, adhésions ou allocations»</b> dans les Organismes Complémentaires si vous déménagez dans une <b>autre commune</b> pour accéder à <b>l'inscription sur les listes électorales</b> et à <b>l'inscription à l'école</b> si vous avez des
												enfants.
											</p>
											<p className="lh-copy mb-1">En passant à l’étape suivante, veuillez être certain que vos organismes (bases et complémentaires) soient bien à jour afin que vous puissiez les informer du changement de situation.</p>
										</div>
									</div>
								</div>
								{userState.events?.some((e) => e.type === "UserRelocation" && e.inProgress) ? (
									<div className="flex-row align-items-center justify-content-end">
										<button className="btn btn-secondary" data-toggle="modal" data-target="#declareRelocation">
											Continuer la déclaration
										</button>
										<button type="button" className="btn btn-primary ml-2 shadow-xs" data-toggle="modal" data-target="#deleteDeclaration">
											Supprimer dossier
										</button>
									</div>
								) : (
									<div className="flex-row align-items-center justify-content-end">
										<button className="btn btn-secondary" data-toggle="modal" data-target="#declareRelocation" onClick={() => $("#declareRelocation").modal("show")}>
											Déclarer un déménagement
										</button>
									</div>
								)}
							</section>
						</div>
					)}
				</div>
			)}

			<DeclareModal userState={userState} relocationDeclarationState={relocationDeclarationState} getDeclaration={getDeclaration} fetchLifeEvents={fetchLifeEvents} generateLettersForUserId={generateLetters} />
			<DeleteModal onDelete={onDeleteRelocation} text={deleteTexts} isLoading={isLoadingDelete} />
		</article>
	);
};
